'use client'

import { useEffect, useRef } from 'react'

interface FloatingParticle {
x: number
y: number
size: number
speed: number
emoji: string
opacity: number
}

interface FloatingEmojiProps {
className?: string
}

const FloatingEmoji: React.FC<FloatingEmojiProps> = ({ className = '' }) => {
const canvasRef = useRef<HTMLCanvasElement>(null)

useEffect(() => {
	const canvas = canvasRef.current
	if (!canvas) return

	const ctx = canvas.getContext('2d')
	if (!ctx) return

	const resizeCanvas = () => {
	canvas.width = canvas.offsetWidth
	canvas.height = canvas.offsetHeight
	}

	resizeCanvas()
	window.addEventListener('resize', resizeCanvas)

	const emojis = ['💕', '💖', '✨', '🌟', '💫', '🍷', '🎂', '👰‍♀️', '🤵', '💍']
	const particles: FloatingParticle[] = []

	// Créer des particules initiales
	for (let i = 0; i < 15; i++) {
	particles.push({
		x: Math.random() * canvas.width,
		y: Math.random() * canvas.height,
		size: Math.random() * 20 + 10,
		speed: Math.random() * 0.5 + 0.2,
		emoji: emojis[Math.floor(Math.random() * emojis.length)],
		opacity: Math.random() * 0.3 + 0.1
	})
	}

	const animate = () => {
	ctx.clearRect(0, 0, canvas.width, canvas.height)

	particles.forEach((particle, index) => {
		// Mettre à jour la position
		particle.y -= particle.speed
		particle.x += Math.sin(particle.y * 0.01) * 0.3

		// Réinitialiser si la particule sort de l'écran
		if (particle.y < -50) {
		particle.y = canvas.height + 50
		particle.x = Math.random() * canvas.width
		}

		// Dessiner la particule
		ctx.save()
		ctx.globalAlpha = particle.opacity
		ctx.font = `${particle.size}px serif`
		ctx.textAlign = 'center'
		ctx.fillText(particle.emoji, particle.x, particle.y)
		ctx.restore()
	})

	requestAnimationFrame(animate)
	}

	animate()

	return () => {
	window.removeEventListener('resize', resizeCanvas)
	}
}, [])

return (
	<canvas
	ref={canvasRef}
	className={`pointer-events-none absolute inset-0 ${className}`}
	style={{ zIndex: 1 }}
	/>
)
}

export default FloatingEmoji
